import { Typography } from "@mui/material";
import "./AddTeam.css";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FormModal from "../../../../Components/Molecules/FormModal/FormModal";
import AddCoachForm from "../../../../Components/Organisms/Forms/AddCoachForm/AddCoachForm";
import AddTeamForm from "../../../../Components/Organisms/Forms/AddTeamForm/AddTeamForm";
import AddMemberForm from "../../../../Components/Organisms/Forms/AddMemberForm/AddMemberForm";
import { coachesURL, membersURL } from "../../../../Hooks/URL";
import { PulseLoader } from "react-spinners";
import config from "../../../../config";

function AddTeam({
  OpenCoach,
  setOpenCoach,
  OpenMember,
  setOpenMember,
  team,
  editId,
  loading,
  editType,
}) {
  return (
    <div className="mainContainer">
      <div className="cont">
        <div className="greyBoxVer">
          <Typography
            sx={{
              color: "primary.main",
              fontSize: { xs: "28px", md: "35px" },
              fontWeight: "500",
              marginBottom: "5px",
            }}
          >
            {editId
              ? editType == "members"
                ? "Edit Team Members"
                : "Edit Team Details"
              : "Add New Team"}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "14px", md: "16px" },
              marginBottom: "20px",
            }}
          >
            {editId ? (
              <>
                Here, you can edit your team for the{" "}
                <strong>
                  {config.APP_NAME == "Code Reg"
                    ? "Code Challenge Competition"
                    : config.APP_NAME == "WeDo Reg"
                    ? "WeDo Challenge Competition"
                    : "International Robot Challenge Competition"}
                </strong>
                . Please fill in the required details accurately to ensure your
                team is ready to participate in the competition.
              </>
            ) : (
              <>
                Here, you can register a new team for the{" "}
                <strong>
                  {config.APP_NAME == "Code Reg"
                    ? "Code Challenge Competition"
                    : config.APP_NAME == "WeDo Reg"
                    ? "WeDo Challenge Competition"
                    : "International Robot Challenge Competition"}
                </strong>
                . Please fill in the required details accurately to ensure your
                team is ready to participate in the competition.
              </>
            )}
          </Typography>
          <Accordion
            sx={{
              boxShadow:
                "0px 0px 10px -1px rgba(0,0,0,0.2),0px 0px 1px -1px rgba(0,0,0,0.14),0px 1px 1px 0px rgba(0,0,0,0.12)",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              Team Registration Guidelines & Steps
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              >
                Team Registration Guidelines:
              </Typography>
              <ol style={{ marginLeft: "30px" }}>
                <li>Manage team details, including students and coaches.</li>
                <li>
                  Ensure all member details are correct before submission.
                </li>
                <li>
                  Teams cannot share members or compete in multiple categories.
                </li>
              </ol>
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              >
                Steps to Register a New Team:
              </Typography>
              <ol style={{ marginLeft: "30px" }}>
                <li>Enter the team name.</li>
                <li>Select Members or add new member.</li>
                <li>Provide the coach/teacher’s information.</li>
                <li>Confirm the team category based on age group.</li>
                <li>Submit the team details for registration.</li>
              </ol>
            </AccordionDetails>
          </Accordion>
        </div>

        <div className="greyBoxVer">
          {(editId && team) || !editId ? (
            <AddTeamForm
              setOpenCoach={setOpenCoach}
              setOpenMember={setOpenMember}
              OpenCoach={OpenCoach}
              OpenMember={OpenMember}
              team={team}
              Edit={editId ? true : false}
              editId={editId}
              editType={editType}
            />
          ) : (
            <div className="loadingBox">
              <PulseLoader color={config.PRIMARY_COLOR} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AddTeam;
